import { AgreementPrices } from '../../shared/AgreementPricesDialog';

export const hasAgreementPricesError = (agreementPrices: AgreementPrices): boolean => {
  return agreementPrices.some((agreementPrice) => agreementPrice.agreement === null);
};
